import Vue from 'vue';
import Vuex from 'vuex';
import isError from 'lodash-es/isError';
import isObject from 'lodash-es/isObject';
import toString from 'lodash-es/toString';

import axios from "axios";
import {RootState} from "./types";

Vue.use(Vuex);

import {RootModule} from "./Modules/RootModule";

const rootStore = new Vuex.Store<RootState>({
    ...RootModule
});

rootStore.subscribeAction({
    error: (action, state, error) => {
        if (!error) return; // promise rejections
        console.error(error);
        try {
            const stackTrace = isError(error) && 'stack' in error ? error.stack
                : (isObject(error) ? JSON.stringify(error) : toString(error));
            axios.post('ClientSideException', {
                message: `Vuex action error for ${action.type}`,
                url: window.location.toString(),
                userAgent: navigator.userAgent,
                stackTrace: stackTrace
            });
        } catch (e) {
            console.error('Error logging client-side exception: ' + e);
        }
    }
});

export default rootStore;